import React from "react";
import { Skeleton } from "@mui/material";
import "./styles/SearchResultsSkeleton.scss";

const ROWS = [
  { title: "22%", storyline: "58%" },
  { title: "38%", storyline: "66%" },
  { title: "46%", storyline: "52%" },
  { title: "30%", storyline: "64%" },
  { title: "26%", storyline: "44%" },
  { title: "42%", storyline: "40%" },
  { title: "32%", storyline: "58%" },
  { title: "28%", storyline: "66%" },
  { title: "16%", storyline: "42%" },
  { title: "30%", storyline: "64%" },
  { title: "46%", storyline: "84%" },
  { title: "42%", storyline: "70%" },
];

const SearchResultsSkeleton = () => (
  <div
    className="searchResultsTable searchResultsSkeleton"
    role="status"
    aria-busy="true"
    aria-label="Carregando resultados"
  >
    <div className="skeletonHeader">
      <Skeleton variant="text" width={64} height={18} animation="wave" />
      <Skeleton variant="text" width={48} height={18} animation="wave" />
    </div>

    {ROWS.map(({ title, storyline }, index) => (
      <div className="skeletonItem" key={index}>
        <div className="skeletonItemTop">
          <Skeleton
            variant="circular"
            width={30}
            height={30}
            animation="wave"
          />
          <Skeleton variant="text" width={title} height={22} animation="wave" />
          <Skeleton variant="text" width={80} height={18} animation="wave" />
        </div>
        <Skeleton
          variant="text"
          width={storyline}
          height={16}
          animation="wave"
        />
      </div>
    ))}
  </div>
);

export default SearchResultsSkeleton;
